export const RECEIVE_UPLOADS = 'RECEIVE_UPLOADS';
export const SORT_UPLOADS = 'SORT_UPLOADS';
export const SET_VIEW = 'SET_VIEW';
export const LIST_VIEW = 'LIST_VIEW';
export const GALLERY_VIEW = 'GALLERY_VIEW';
export const TILE_VIEW = 'TILE_VIEW';
export const FILTER_UPLOADS = 'FILTER_UPLOADS';
export const SET_UPLOAD_METADATA = 'SET_UPLOAD_METADATA';
export const SET_UPLOAD_VIEWER_METADATA = 'SET_UPLOAD_VIEWER_METADATA';
export const SET_UPLOAD_PAGEVIEWS = 'SET_UPLOAD_PAGEVIEWS';
export const RESET_UPLOAD_PAGEVIEWS = 'RESET_UPLOAD_PAGEVIEWS';
